let defaultSessionExpiredHandler: (() => void) | undefined = undefined;

export const setDefaultSessionExpiredHandler = (handler: () => void): void => {
  defaultSessionExpiredHandler = handler;
};

// Use this to handle token expiry logouts for api calls that contain bearer tokens
export async function apiFetch(
  url: string,
  options?: RequestInit,
  onSessionExpired?: () => void
): Promise<Response> {
  const response = await fetch(url, options);

  // only attempt JSON parsing if the server really sent JSON
  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    try {
      // Clone the response to check its JSON without consuming the body.
      const clonedResponse = response.clone();
      const data: any = await clonedResponse.json();

      if (
        data &&
        (data.detail === 'Session could not be found.' ||
          data.detail === 'Invalid session token')
      ) {
        // Use the provided handler, or fall back to the default if available.
        if (onSessionExpired && typeof onSessionExpired === 'function') {
          onSessionExpired();
        } else if (defaultSessionExpiredHandler) {
          defaultSessionExpiredHandler();
        }
      }
    } catch (error) {
      console.error('Error processing API response:', error);
    }
  }

  return response;
}
